import { createContext, useContext } from "react";

import type { ReactNode } from "react";

/**
 * Id de visita del documento, sólo en el server: `entry.server.tsx` lo toma del `loadContext` y lo
 * deja acá para que `root.tsx` lo escriba en el snippet de render. En el navegador vale `null`
 * (el snippet ya está en el HTML; ver `VisitRenderScript`).
 */
const VisitIdContext = createContext<string | null>(null);

export function VisitIdProvider({
  value,
  children,
}: {
  value: string | null;
  children: ReactNode;
}) {
  return <VisitIdContext.Provider value={value}>{children}</VisitIdContext.Provider>;
}

export const useVisitId = () => useContext(VisitIdContext);
